import {React, useEffect, useState} from 'react'
import "./Leaveform.css"
import LeaveListView from './ListviewLeave';
import DatePicker from "react-datepicker";
import axios from 'axios'
import Moment from 'moment';
import image from './img/Back.png'

export default function LeaveRequestForm(){
    const [template,setTemplate] = useState("Create")

    const [category,setCategory] = useState("")
    const [reason,setReason] = useState("")
    const [fromDate,setFromDate] = useState(new Date())
    const [date, setDate] = useState(new Date());
    const [duration,setDuration] = useState("")
    const [toDate,setToDate] = useState(new Date())

    const redirectToLanding = () =>{
        window.location.href = "/landingPage"
    }
    const redirectToCreate = () =>{
        setTemplate("Create")
    }
    const listleaves = () =>{
        setTemplate("List")
    }
    const resetDetails=()=>{
        setCategory("")
        setReason("")
        setDuration("")
        setToDate(new Date())
        setFromDate(new Date())

    }


    const onSubmit = () =>{
        const params = {"leaveType":category,"reason":reason,"from_date" : fromDate,"to_date" : toDate,"duration":duration,"status":"Initiated","employee_name":"Sri"}
        if(category!=""&&reason!==""&&duration!==""){
            axios({
                method: 'post',
                url: `http://127.0.0.1:8000/leave/createLeave`,
                headers: { 'Content-Type': 'application/json','Access-Control-Allow-Origin' : '*' },
                data : params
    
            }).then(response => {
                alert("Successfuly Created!")
                resetDetails()
            })  
            .catch(error => {
                console.error(error);
            });
        }
        else{
            alert("Please Enter all the mandatory fields")
        }
        
    }

    return(
        <div>
        { 
            template == "Create" ?
        <div >
            <div className="heading">   
                <img src={image}  className="goBack" onClick={redirectToLanding}/>
                <span>Apply Leave Request</span>
            </div>
            <div class="form-parent">
            <span className="leave-list" onClick={listleaves}>List Leave Requests</span><br/>
            
            <div className="input select leaveDiv"><label for="EmployeeLeaveRequestLeaveCategoryId">Leave Type</label>
                <select  name="" className="selectbox setInputWidth" value={category} id="EmployeeLeaveRequestLeaveCategoryId" onChange={e => setCategory(e.target.value)}>
                    <option value="">--Select Leave Category--</option>
                    <option value="Earned Leave">Earned Leave</option>
                    <option value="Maternity Leave">Maternity Leave</option>
                    <option value="Medical Leave">Medical Leave</option>
                </select>
            </div><br/>
            <div className="input textarea"><label>Reason</label><textarea name="" value={reason} cols="30" rows="6" className="textarea" id="EmployeeLeaveRequestLeaveReason"  onChange={e => setReason(e.target.value)}></textarea></div>
            <br/>
            <div className="input text">
                <label>From Date</label>
                <input className="setInputWidth" type="date" value={fromDate} selected ="fromDate" onChange={(date)=> setFromDate(date.target.value)}/>
            </div><br/>
            <div className="input text">
                <label >To Date</label>
                <input className="setInputWidth" type="date" value={toDate} selected ="toDate"  onChange={(date)=> setToDate(date.target.value)}/>
            </div><br/>
            <div>
                <label>Duration</label>
                <input className="setInputWidth" type = "number" value={duration} onChange={e => setDuration(e.target.value)}/>
            </div><br/>
            <input type="button" className="submitBtn" value="Submit" onClick={onSubmit}/>
            <input type="button" className="cancelBtn" value="Cancel" onClick={resetDetails}/>
        </div>
        </div> :
        <div>
            <div className="heading">   
                <img src={image}  className="goBack" onClick={redirectToCreate}/>
                <span>List Leave Request</span>
            </div><br/>
            <LeaveListView/>
        </div>
        
    }
    </div>
    )
}